import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../navbar/navbar.scss";

import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { NavLink } from "react-router-dom";
import {LayoutGrid,Users, Settings} from "lucide-react";


const items = [
  { to: "/warehouses", label: "Almacenes", icon: LayoutGrid },
  // { to: "/tablestorage", label: "Tabla", icon: Users },
  
 
];

const footerItems = [
  { to: "/configuracion", label: "Configuración", icon: Settings },
];

const Navbar = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const closeTimer = useRef(null);

  const handleEnter = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setOpen(true);
  };

  const handleLeave = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setOpen(false), 140);
  };

  useEffect(() => {
    return () => {
      if (closeTimer.current) clearTimeout(closeTimer.current);
    };
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => e.key === "Escape" && setOpen(false);
    if (open) window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open]);

  const goTo = (path) => {
    navigate(path);
    setOpen(false);
  };

  return (
    <div className="navbar">
      <div className="options">
        <IconButton
          className="menu-trigger"
          onMouseEnter={handleEnter}
          onMouseLeave={handleLeave}
        >
          <MenuIcon className="menu-icon" />
        </IconButton>

        <Drawer
          anchor="left"
          open={open}
          onClose={() => setOpen(false)}
          ModalProps={{ keepMounted: true }}
          PaperProps={{
            className: "drawer-paper",
            onMouseEnter: handleEnter,
            onMouseLeave: handleLeave,
          }}
        >
          <Box className="drawer-header">
            <div className="drawer-brand">
              <div className="drawer-logo">C</div>
              <div>
                <div className="drawer-title">Menú</div>
                <div className="drawer-subtitle">Navegación</div>
              </div>
            </div>
          </Box>

          <Divider className="drawer-divider" />
                <Box className="drawer-content">
                    <nav className="sidebar__nav">
                        {items.map((it) => {
                        const Icon = it.icon;
                        return (
                            <NavLink
                            key={it.to}
                            to={it.to}
                            className={({ isActive }) =>
                                `sidebar__item ${isActive ? "is-active" : ""}`
                            }
                            >
                            <span className="sidebar__icon">
                                <Icon size={18} />
                            </span>
                            <span className="sidebar__text">{it.label}</span>
                            </NavLink>
                        );
                        })}
                    </nav>

                    <div className="sidebar__spacer" />

                    <nav className="sidebarnav sidebar__nav--bottom">
                        {footerItems.map((it) => {
                        const Icon = it.icon;
                        return (
                            <NavLink
                            key={it.to}
                            to={it.to}
                            className={({ isActive }) =>
                                `sidebar__item ${isActive ? "is-active" : ""}`
                            }
                            >
                            <span className="sidebar__icon">
                                <Icon size={18} />
                            </span>
                            <span className="sidebar__text">{it.label}</span>
                            </NavLink>
                        );
                        })}
                    </nav>
                </Box>


          
            
            
                    
        </Drawer>
      </div>
    </div>
  );
};

export default Navbar;
